import React from 'react';
import { VictoryAxis, VictoryLabel } from 'victory';

interface XAXisProps {
  tickValues: number[],
  tickFormat,
  fill: string,
  dy: number,
  horizontalTickCount: number,
}

const XAxis = ({
  tickValues, tickFormat, fill, dy, horizontalTickCount,
}: XAXisProps) => <VictoryAxis
    crossAxis={false}
    tickCount={horizontalTickCount}
    {...{ tickValues, tickFormat }}
    fixLabelOverlap
    style={{
      axis: { stroke: 'none' },
      tickLabels: { fontSize: 14, lineHeight: 11 },
    }}
    tickLabelComponent={<VictoryLabel
      {...{ dy }}
      dx={-20}
      style={{
        fill,
        fontSize: 14,
        lineHeight: 11,
        strokeWidth: 0,
        fontFamily: 'Poppins_400Regular',
        textAnchor: 'center',
      }}
    />}
  />;

export default XAxis;
